module.exports = __webpack_public_path__ + "static/media/sponcer_youcam-enhance-api.1f998962.svg";